import { action } from "satcheljs";
import { Moment } from "moment";

const createTimeOffRequest = action(
    "CREATE_TIMEOFF_REQUEST",
    (
        message: string,
        startTime: Moment,
        endTime: Moment,
        timeOffReasonId: string,
        requestedTimeOffBalance?: number
        ) => ({
        message: message,
        startTime: startTime,
        endTime: endTime,
        timeOffReasonId: timeOffReasonId,
        requestedTimeOffBalance: requestedTimeOffBalance
    })
);

export default createTimeOffRequest;